import { Controller } from "@hotwired/stimulus"
import * as Sentry from "@sentry/browser"
import {
  IANAToRailsTimezone,
  railsTimeZoneMatchesIANA,
} from "web/services/railsTimeZone"

export default class TimeZoneBannerController extends Controller {
  static targets = ["message", "timezone", "timezoneInput"]

  connect() {
    if (this.hasDifferentTimeZones() && this.railsSupportsTimeZone()) {
      this.setPromptMessaging()
      this.timezoneInputTarget.value = this.browserRailsTimeZone()

      this.element.classList.remove("hidden")
    }
  }

  setPromptMessaging() {
    const promptMessage =
      current.user.timeZone !== ""
        ? "Change time zone to"
        : "Set your time zone to"

    this.messageTarget.textContent = promptMessage
    this.timezoneTarget.textContent = this.browserRailsTimeZone()
  }

  hasDifferentTimeZones() {
    return !railsTimeZoneMatchesIANA(
      this.browserIANATimeZone(),
      current.user.timeZone
    )
  }

  browserIANATimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  browserRailsTimeZone() {
    return IANAToRailsTimezone(this.browserIANATimeZone())
  }

  railsSupportsTimeZone() {
    if (typeof this.browserRailsTimeZone() == "undefined") {
      Sentry.captureMessage(
        `TimeZoneBanner can not identify (${this.browserIANATimeZone()})`
      )
      return false
    } else {
      return true
    }
  }
}
